import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ApplicationState } from "../store";
import { Categories, MenuTextData, ProductsData, UserData } from "../models/types";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { searchListCategories, searchProducts } from "../store/products/action";
import ProductCard from "./ProductCard";
import { Box, Grid, Hidden } from "@material-ui/core";
import ProductBreadcrumb from "./ProductBreadcrumb";
import ProductTree from "./ProductTree";
import { appendTreeSelection } from "../store/menu/action";
import ProductCategoryCard from "./ProductCategoryCard";
import ga from "../shared/ga-init";

interface PropsFromState {
  text: MenuTextData;
  textLoading: boolean;
  language: string;
  loading: boolean;
  listLoading: boolean;
  errors?: string;
  products: ProductsData[];
  listCategories: Categories[];
  token: UserData["token"];
}

interface propsFromDispatch {
  searchProducts: (token: string, type: string, id: string) => any;
  appendTreeSelection: (type: string, id: string) => any;
  searchCategories: (id: string) => any;
}

interface IProps {
  type: string,
  id?: string
}

type AllProps = IProps & PropsFromState & propsFromDispatch;

const ProductList: React.FC<AllProps> = ({
  text,
  textLoading,
  type,
  id,
  language,
  loading,
  listLoading,
  products,
  listCategories,
  token,
  searchProducts,
  appendTreeSelection,
  searchCategories
}) => {
  const productList = Array.isArray(products) ? products : [products].filter(Boolean);
  const categoryList = Array.isArray(listCategories) ? listCategories : [listCategories].filter(Boolean);

  useEffect(() => {
    appendTreeSelection(type, id || '');
    searchCategories(id || '');
    searchProducts(token, type, id || '');
  }, [appendTreeSelection, searchCategories, searchProducts, token, type, id]);

  useEffect(() => {
    ga.trackPageView()
  }, [type, id])

  return (
    <Box pl={2} pr={2} pt={3} pb={2}>
      <ProductBreadcrumb />
      <Grid
        container
        spacing={0} 
        direction="row"
        justify="center"
      >

      <Hidden smUp>
        <Grid item xs={12} sm={12} >
          <Grid
            container
            spacing={2}
            direction="row"
            justify-centent="left"
          >
            {!loading ? productList.map(item => (
              <Grid item xs={6} sm={6} md={3} >
                <ProductCard product={item} language={language} />
              </Grid>
            )) : null}
            {!listLoading&&!textLoading ? categoryList.map(item => (
              <Grid item xs={6} sm={6} md={3} >
                <ProductCategoryCard category={item.code} name={text[item.code]?.value[language]} image={text[item.code]?.image || ''} />
              </Grid>
            )) : null}
          </Grid>
        </Grid>
      </Hidden>
      <Hidden smDown>
        <Grid item xs={3} sm={3} >
          <ProductTree />
        </Grid>
        <Grid item xs={9} sm={9} >
          <Grid
            container
            spacing={2}
            direction="row"
            justify-centent="left"
          >
            {!loading ? productList.map(item => (
              <Grid item xs={6} sm={6} md={3} >
                <ProductCard product={item} language={language} />
              </Grid>
            )) : null}
            {!listLoading&&!textLoading ? categoryList.map(item => (
              <Grid item xs={6} sm={6} md={3} >
                <ProductCategoryCard category={item.code} name={text[item.code]?.value[language]} image={text[item.code]?.image || ''} />
              </Grid>
            )) : null}
          </Grid>
        </Grid>
      </Hidden>
      </Grid>
    </Box>
  );
};

const mapStateToProps = ({ language, products, user, menu }: ApplicationState) => ({
  text: menu.text,
  textLoading: menu.loading,
  language: language.language,
  loading: products.loading,
  errors: products.errors,
  products: products.products,
  listCategories: products.categoryList,
  listLoading: products.categoryListLoading,
  token: user.user["token"]
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    searchProducts: (token: string, type?: string, id?: string) => {
      dispatch(searchProducts(token, type, id));
    },
    appendTreeSelection: (type: string, id: string) => {
      dispatch(appendTreeSelection(type, id));
    },
    searchCategories: (id: string) => {
      dispatch(searchListCategories(id));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
